import './Forgotpw.css';

import { Component } from 'react';
import { Flow } from 'flow-react';
import { Container, Row, Col} from 'react-bootstrap';

class Forgotpw extends Component {
  state = { initdone:false, success:false, user:'' ,mess:'' }

  changeInput = evt => {
    this.setState({[evt.target.name]: evt.target.value});
  }

  handleSubmit = evt => {
    evt.preventDefault();
    if (this.state.initdone)
      this.trybaseLogin();
    else
      this.props.flow.init()
        .then(()=>{ 
          this.setState({initdone: true});
          this.trybaseLogin();
				});
  }
	
	
	
	async trybaseLogin() {
		this.resetpw();
		// this.props.flow.login('pjdemo_dummy_1','gDw5%_wE')
			// .then(res=>{
				// this.resetpw()
			// }).catch(e => {
				// console.error(e);
		// });
	}

	
	
  resetpw = () => {
    this.props.flow.ftvfeForgotPw(this.state.user)
      .then(res=>{
          this.setState({mess:res.msg,success:res.success});
      }).catch(e => {
					console.log(e);
      });
  }



  render() {
		let errdiv = null;
		if(this.state.mess != '') {
			errdiv = <div className="smallerrormess">{ this.state.mess }</div>
			if(this.state.success)  errdiv = <div className="smallsuccessmess">{ this.state.mess }</div>
		}
    return (
			<Container className="Login" fluid>
				<Row>
				<Col md={1} /> 
					<Col md={11}> 
						<form className="form" onSubmit={this.handleSubmit}>
							<div className="formrow">
								<div className="pwforgot_instruct">Pour réinitialiser votre mot de passe, merci de préciser votre adresse e-mail.</div>
							</div>
							<div className="formrow">
								<div>E-mail</div>
								<input type="text" value={ this.state.user } name="user" onChange={ this.changeInput } />
									{errdiv}
							</div>
							<div className="formrow logbutrow">
								<input className="loginsubmit" type="submit" value="Envoyer" />
								<div onClick={  this.props.logincb } className="pwforgotlink">Se connecter</div>
							</div>
						</form>
					</Col>
				</Row>
      </Container>
    );
  }
}

export default Flow.injectFlow(Forgotpw);